import React from "react";
import "./Contact.css";

const Contact = () => {
  const handleCallClick = () => {
    window.location.href = "tel:+919380104188"; // Direct call
  };

  const handleWhatsAppClick = () => {
    window.open(
      "https://wa.me/919380104188?text=Hi%20I%20am%20interested%20in%20your%20Capgemini%20training",
      "_blank"
    ); // WhatsApp Business Chat
  };
  return (
    <div className="contactSection">
      <div className="contactBlockk">
        <div className="contactAside">
          <h3>Contact Us</h3>
          <div className="contactAsideText">
            <p>
              <i class="fa-solid fa-location-dot"></i> #299, 3rd floor, Amber,
              HBCS Layout, Vyalikaval, Bangalore - 560045
            </p>
            <p>
              <i class="fa-solid fa-envelope"></i> email1234@gmail.com
            </p>
            <p>
              <i class="fa-solid fa-phone"></i>70222 80365
            </p>
          </div>
          <div className="contactAsideBtn">
            <button onClick={handleCallClick}>
              <i class="fa-solid fa-phone"></i> Call Us
            </button>
            <button onClick={handleWhatsAppClick}>
              <i class="fa-brands fa-whatsapp"></i> WhatsApp
            </button>
          </div>
        </div>
        <div className="contactMain">
          <h2>Get In Touch</h2>
          <form>
            <label>Name</label>
            <input type="text" />
            <label>Email</label>
            <input type="email" />
            <label>Message</label>
            <textarea
              rows={5}
              placeholder="Write your message here..."
            ></textarea>
            <div>
              <input type="checkbox" />I agree to the Terms and Conditions
            </div>
            <button>Submit</button>
          </form>
        </div>
      </div>
      <div className="contactBlock2">
        <div className="contactBlock2Text">
          <h3>Head Office (USA)</h3>
          <p>4640 Melody Dr Unit C, Concord, California 94521</p>
          <p>+1 (415) 619 4657</p>
        </div>
        <div className="contactBlockk2Sub">
          <div className="contactBlock2Text">
            <h3>Branch Office (India)</h3>
            <p>
              #299, 3rd floor, Amber, HBCS Layout, Vyalikaval, Bangalore -
              560045
            </p>
            <p>+91 7022280365</p>
          </div>
          <div className="contactBlock2Text">
            <h3>Mumbai Office (India)</h3>
            <p>
              Shop No. 7, Guxu Arjun Apartments, Gujjar Lane, Santacruz(W),
              Mumbai - 400054
            </p>
            <p>+91 9820252529</p>
          </div>
          <div className="contactBlock2Text">
            <h3>Chennai Office (India)</h3>
            <p>
              CHN Technologies Pvt. Ltd, New No. 70 / Old No. 2 Main Road, CIT
              Nagar, Chennai - 600035
            </p>
            <p>+91 978981336</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
